const checkFileSize = (file, maxSize = 10) => {
  if (file) {
    const size = file.size / 1024;
    if (size < maxSize) {
      return true;
    }
  }

  return false;
};

const checkFileType = (
  file,
  types = ["application/jpg", "image/jpeg", "image/png"]
) => {
  if (types?.includes(file?.type)) return true;
  return false;
};

export { checkFileSize, checkFileType };
